import {zip, of} from 'rxjs';
import {flatMap, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import * as OrganizationObservables from 'web-app/react/entities/organizations/epics';
import OrganizationPerson from 'web-app/react/entities/organization-persons/model';
import * as OrganizationPersonApi from 'web-app/react/entities/organization-persons/api';
import * as OrganizationPersonActions from 'web-app/react/entities/organization-persons/actions';

import * as Actions from './actions';

const fetchAllOrganizationOverviewData = action$ =>
    action$.ofType(Actions.fetchData.type).mergeMap(({payload}) => {
        const {organizationId} = payload;

        return zip(
            OrganizationObservables.fetchOrganizationObservable(organizationId),
            OrganizationPersonApi.getOrganizationPersons(organizationId),
        ).pipe(
            flatMap(([orgActions, organizationPersonsData]) => {
                const persons = (organizationPersonsData as any).organizationPersons.map(p =>
                    OrganizationPerson.fromAPI(p),
                );

                return (orgActions as any[]).concat([
                    OrganizationPersonActions.fetchAllSuccess.action(persons),
                    Actions.fetchDataSuccess.action(),
                ]);
            }),
            catchError(e => of(Actions.fetchDataFailed.action(e))),
        );
    });

export default combineEpics(fetchAllOrganizationOverviewData);
